import React, { forwardRef } from 'react';

import useClassy from '@core/hooks/useClassy';
import { useSuperHubStore } from '@core/store';

import type { ButtonProps } from '@ui/Button';
import Button from '@ui/Button';
import Icon from '@ui/Icon';

import { useCreateBranchMetaContext } from './Context';
import styles from './index.module.scss';

const CreateBranchButton = forwardRef<HTMLButtonElement, ButtonProps>(function CreateBranchButton(
  { children, onClick, ...rest },
  ref,
) {
  const bem = useClassy(styles, 'CreateBranch');

  const { version, source } = useCreateBranchMetaContext();
  const updateEphemeralBranch = useSuperHubStore(s => s.branches.updateEphemeralBranch);

  return (
    <Button
      ref={ref}
      aria-label="Create Branch"
      className={bem('-button')}
      kind="contrast"
      onClick={e => {
        updateEphemeralBranch({ base: version.name, source });
        onClick?.(e);
      }}
      size="xs"
      text
      uppercase={false}
      {...rest}
    >
      {children || (
        <>
          <Icon aria-hidden="true" name="plus" />
          Branch
        </>
      )}
    </Button>
  );
});

export default CreateBranchButton;
